import {Box, Button, CircularProgress, Typography,} from '@material-ui/core';
import {ArrowBack, Group, Print, Refresh} from '@material-ui/icons';
import {useStyles} from './styles';
import {BoxDetails} from "./box-details";
import {AssessmentResultsListComponent} from "./assessment-results-list";
import {useHistory, useParams} from "react-router-dom";
import {useCallback, useEffect, useState} from "react";
import {
    useQuizAssessmentAvailabilityDataProvider
} from "../../../../providers/data-provider/quiz-assessment-availability.data.provider";
import {PrintClassTest} from "../../component/print-class-test";
import {ExportResultsAction} from "./export-results-action";


export function QuizAssessmentResultsPage() {
  const [availability, setAvailability] = useState();
  const [studentResults, setStudentResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const classes = useStyles();
  const availabilityRepo = useQuizAssessmentAvailabilityDataProvider()
  const params = useParams()
  const history = useHistory();
  const loadTest = useCallback(() => {
    setLoading(true);
    return Promise.all([
      availabilityRepo.findAvailability(params.testId).then(res => setAvailability(res.data)),
      availabilityRepo.listAvailabilityResultItem(params.testId).then(res => setStudentResults(res.data)),
    ]).finally(() => setLoading(false))
  }, [params.testId])

  useEffect(() => {
    loadTest()
  }, [loadTest]);


  return (
    <Box width={'100%'}>
      <Box className={classes.breadcrumb}>
        <ArrowBack fontSize="small" className={classes.backArrow} onClick={() => history.goBack()} />
        <Typography variant="body2" className={classes.breadcrumbText} onClick={() => history.goBack()}>
          Painel de Controle
        </Typography>
        <Typography variant="body2" className={classes.breadcrumbSeparator}>{'>'}</Typography>
        <Typography variant="body2" className={classes.breadcrumbCurrent}>
          {availability?.name}
        </Typography>
      </Box>

      <BoxDetails
        availabilityName={availability?.name}
        durationInMinutes={availability?.durationInMinutes}
        start={availability?.start}
        end={availability?.end}
        questionAmount={availability?.questionAmount}
        className={availability?.classes?.map(w => w.name).join(',')}
        assessmentType={availability?.assessmentType}
      />

      <Box className={classes.sectionHeader}>
        <Box className={classes.sectionHeaderLeft}>
          <Group className={classes.sectionIcon} />
          <Typography variant="h6" className={classes.sectionTitle}>Alunos da turma</Typography>
        </Box>

          <Box>
              {availability?.assessmentType === 'printed' && (
                  <PrintClassTest availabilityId={params.testId} assessmentName={availability?.name} />
              )}

              <ExportResultsAction
                  studentResults={studentResults}
                  assessmentType={availability?.assessmentType}
                  availabilityName={availability?.name}
                  disabled={loading}
              />

              <Button
                  variant={'outlined'}
                  color={'default'}
                  size={'small'}
                  startIcon={loading ? <CircularProgress size={16} /> : <Refresh />}
                  onClick={loadTest}
                  disabled={loading}
              >
                  Atualizar Dados
              </Button>
          </Box>
      </Box>

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" py={6}>
          <CircularProgress />
        </Box>
      ) : (
        <AssessmentResultsListComponent
          studentResults={studentResults}
          onSubmitted={loadTest}
          assessmentType={availability?.assessmentType}
        />
      )}
    </Box>
  );
}